import { QuestionOption } from "src/app/modal/questionnaire.models";

export class PolicyHolderService {

  public static CommodityQuestionOptions: Array<QuestionOption> = [
    {
      "code": "AIRCRAFT ENGINES",
      "helpText": "",
      "label": "AIRCRAFT ENGINES",
      "sequence": 1,
      "value": "AIRCRAFT ENGINES",
      "isEligible": true
    },
    {
      "code": "AIRCRAFT PARTS NOT ENGINES",
      "helpText": "",
      "label": "AIRCRAFT PARTS NOT ENGINES",
      "sequence": 2,
      "value": "AIRCRAFT PARTS NOT ENGINES",
      "isEligible": true
    },
    {
      "code": "ALCOHOLIC BEVERAGES EXCEPT BEER AND WINE",
      "helpText": "",
      "label": "ALCOHOLIC BEVERAGES EXCEPT BEER AND WINE",
      "sequence": 3,
      "value": "ALCOHOLIC BEVERAGES EXCEPT BEER AND WINE",
      "isEligible": false
    },
    {
      "code": "ALUMINUM",
      "helpText": "",
      "label": "ALUMINUM",
      "sequence": 4,
      "value": "ALUMINUM",
      "isEligible": true
    },
    {
      "code": "ANIMAL BYPRODUCTS",
      "helpText": "",
      "label": "ANIMAL BYPRODUCTS",
      "sequence": 5,
      "value": "ANIMAL BYPRODUCTS",
      "isEligible": true
    },
    {
      "code": "APPLIANCES EXCEPT TV AND STEREO",
      "helpText": "",
      "label": "APPLIANCES EXCEPT TV AND STEREO",
      "sequence": 6,
      "value": "APPLIANCES EXCEPT TV AND STEREO",
      "isEligible": true
    },
    {
      "code": "ASPHALT - HOT",
      "helpText": "",
      "label": "ASPHALT - HOT",
      "sequence": 7,
      "value": "ASPHALT - HOT",
      "isEligible": true
    },
    {
      "code": "ASPHALT - NOT HOT",
      "helpText": "",
      "label": "ASPHALT - NOT HOT",
      "sequence": 8,
      "value": "ASPHALT - NOT HOT",
      "isEligible": true
    },
    {
      "code": "ATV's AND GOLF CARTS",
      "helpText": "",
      "label": "ATV's AND GOLF CARTS",
      "sequence": 9,
      "value": "ATV's AND GOLF CARTS",
      "isEligible": true
    },
    {
      "code": "AUTO ACCESSORES PARTS (NOT TIRES)",
      "helpText": "",
      "label": "AUTO ACCESSORES PARTS (NOT TIRES)",
      "sequence": 10,
      "value": "AUTO ACCESSORES PARTS (NOT TIRES)",
      "isEligible": true
    },
    {
      "code": "AUTOMOBILES",
      "helpText": "",
      "label": "AUTOMOBILES",
      "sequence": 11,
      "value": "AUTOMOBILES",
      "isEligible": false
    },
    {
      "code": "BAGGED FERTILIZER",
      "helpText": "",
      "label": "BAGGED FERTILIZER",
      "sequence": 12,
      "value": "BAGGED FERTILIZER",
      "isEligible": false
    },
    {
      "code": "BAKED GOODS",
      "helpText": "",
      "label": "BAKED GOODS",
      "sequence": 13,
      "value": "BAKED GOODS",
      "isEligible": true
    },
    {
      "code": "BEER WINE (NO LIQUOR)",
      "helpText": "",
      "label": "BEER WINE (NO LIQUOR)",
      "sequence": 14,
      "value": "BEER WINE (NO LIQUOR)",
      "isEligible": true
    },
    {
      "code": "BEVERAGES",
      "helpText": "",
      "label": "BEVERAGES",
      "sequence": 15,
      "value": "BEVERAGES",
      "isEligible": true
    },
    {
      "code": "BOATS",
      "helpText": "",
      "label": "BOATS",
      "sequence": 16,
      "value": "BOATS",
      "isEligible": false
    },
    {
      "code": "BOTTLES (PLASTIC)",
      "helpText": "",
      "label": "BOTTLES (PLASTIC)",
      "sequence": 17,
      "value": "BOTTLES (PLASTIC)",
      "isEligible": true
    },
    {
      "code": "BULK FERTILIZER",
      "helpText": "",
      "label": "BULK FERTILIZER",
      "sequence": 18,
      "value": "BULK FERTILIZER",
      "isEligible": true
    },
    {
      "code": "BUSINESS DOCUMENTS NON-NEGOTIABLE SECURITIES MONEY",
      "helpText": "",
      "label": "BUSINESS DOCUMENTS NON-NEGOTIABLE SECURITIES MONEY",
      "sequence": 19,
      "value": "BUSINESS DOCUMENTS NON-NEGOTIABLE SECURITIES MONEY",
      "isEligible": false
    },
    {
      "code": "CAMERAS AND FILM",
      "helpText": "",
      "label": "CAMERAS AND FILM",
      "sequence": 20,
      "value": "CAMERAS AND FILM",
      "isEligible": false
    },
    {
      "code": "CANNED GOODS",
      "helpText": "",
      "label": "CANNED GOODS",
      "sequence": 21,
      "value": "CANNED GOODS",
      "isEligible": true
    },
    {
      "code": "CARPET (NOT ORIENTAL)",
      "helpText": "",
      "label": "CARPET (NOT ORIENTAL)",
      "sequence": 22,
      "value": "CARPET (NOT ORIENTAL)",
      "isEligible": true
    },
    {
      "code": "CARPET ORIENTAL",
      "helpText": "",
      "label": "CARPET ORIENTAL",
      "sequence": 23,
      "value": "CARPET ORIENTAL",
      "isEligible": false
    },
    {
      "code": "CASKETS",
      "helpText": "",
      "label": "CASKETS",
      "sequence": 24,
      "value": "CASKETS",
      "isEligible": true
    },
    {
      "code": "CATTLE",
      "helpText": "",
      "label": "CATTLE",
      "sequence": 25,
      "value": "CATTLE",
      "isEligible": false
    },
    {
      "code": "CD'S/DVD'S/VIDEO GAMES/TAPES",
      "helpText": "",
      "label": "CD'S/DVD'S/VIDEO GAMES/TAPES",
      "sequence": 26,
      "value": "CD'S/DVD'S/VIDEO GAMES/TAPES",
      "isEligible": true
    },
    {
      "code": "CEMENT (BULK)",
      "helpText": "",
      "label": "CEMENT (BULK)",
      "sequence": 27,
      "value": "CEMENT (BULK)",
      "isEligible": true
    },
    {
      "code": "CEMENT (DRY AND BAGGED)",
      "helpText": "",
      "label": "CEMENT (DRY AND BAGGED)",
      "sequence": 28,
      "value": "CEMENT (DRY AND BAGGED)",
      "isEligible": true
    },
    {
      "code": "CHEMICALS - ACIDIC, CORROSIVE, FLAMMABLE, OR EXPLOSIVE",
      "helpText": "",
      "label": "CHEMICALS - ACIDIC, CORROSIVE, FLAMMABLE, OR EXPLOSIVE",
      "sequence": 29,
      "value": "CHEMICALS - ACIDIC, CORROSIVE, FLAMMABLE, OR EXPLOSIVE",
      "isEligible": true
    },
    {
      "code": "CHEMICALS - NON ACIDIC, NON CORROSIVE, NON FLAMMABLE, AND NON EXPLOSIVE",
      "helpText": "",
      "label": "CHEMICALS - NON ACIDIC, NON CORROSIVE, NON FLAMMABLE, AND NON EXPLOSIVE",
      "sequence": 30,
      "value": "CHEMICALS - NON ACIDIC, NON CORROSIVE, NON FLAMMABLE, AND NON EXPLOSIVE",
      "isEligible": true
    },
    {
      "code": "CHINA AND CERAMICS",
      "helpText": "",
      "label": "CHINA AND CERAMICS",
      "sequence": 31,
      "value": "CHINA AND CERAMICS",
      "isEligible": true
    },
    {
      "code": "CIGARETTES AND CIGARS",
      "helpText": "",
      "label": "CIGARETTES AND CIGARS",
      "sequence": 32,
      "value": "CIGARETTES AND CIGARS",
      "isEligible": false
    },
    {
      "code": "CLEANING SUPPLIES & COMPOUNDS",
      "helpText": "",
      "label": "CLEANING SUPPLIES & COMPOUNDS",
      "sequence": 33,
      "value": "CLEANING SUPPLIES & COMPOUNDS",
      "isEligible": true
    },
    {
      "code": "CLOTHING SHOES (NON DESIGNER)",
      "helpText": "",
      "label": "CLOTHING SHOES (NON DESIGNER)",
      "sequence": 34,
      "value": "CLOTHING SHOES (NON DESIGNER)",
      "isEligible": true
    },
    {
      "code": "CLOTHING SHOES- LADIES AND MEN DRESS APPAREL",
      "helpText": "",
      "label": "CLOTHING SHOES- LADIES AND MEN DRESS APPAREL",
      "sequence": 35,
      "value": "CLOTHING SHOES- LADIES AND MEN DRESS APPAREL",
      "isEligible": false
    },
    {
      "code": "COAL",
      "helpText": "",
      "label": "COAL",
      "sequence": 36,
      "value": "COAL",
      "isEligible": false
    },
    {
      "code": "COILED STEEL",
      "helpText": "",
      "label": "COILED STEEL",
      "sequence": 37,
      "value": "COILED STEEL",
      "isEligible": true
    },
    {
      "code": "COMMUNICATIONS EQUIPMENT",
      "helpText": "",
      "label": "COMMUNICATIONS EQUIPMENT",
      "sequence": 38,
      "value": "COMMUNICATIONS EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "COMPUTERS",
      "helpText": "",
      "label": "COMPUTERS",
      "sequence": 39,
      "value": "COMPUTERS",
      "isEligible": false
    },
    {
      "code": "CONSTRUCTION EQUIPMENT",
      "helpText": "",
      "label": "CONSTRUCTION EQUIPMENT",
      "sequence": 40,
      "value": "CONSTRUCTION EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "CONTAINERIZED FREIGHT",
      "helpText": "",
      "label": "CONTAINERIZED FREIGHT",
      "sequence": 41,
      "value": "CONTAINERIZED FREIGHT",
      "isEligible": true
    },
    {
      "code": "COPPER",
      "helpText": "",
      "label": "COPPER",
      "sequence": 42,
      "value": "COPPER",
      "isEligible": false
    },
    {
      "code": "COSMETICS AND PERFUME",
      "helpText": "",
      "label": "COSMETICS AND PERFUME",
      "sequence": 43,
      "value": "COSMETICS AND PERFUME",
      "isEligible": true
    },
    {
      "code": "COTTON (NON-GINNED)",
      "helpText": "",
      "label": "COTTON (NON-GINNED)",
      "sequence": 44,
      "value": "COTTON (NON-GINNED)",
      "isEligible": true
    },
    {
      "code": "DAIRY",
      "helpText": "",
      "label": "DAIRY",
      "sequence": 45,
      "value": "DAIRY",
      "isEligible": true
    },
    {
      "code": "DANGEROUS ARTICLES, EXPLOSIVES, CORROSIVES, FLAMMABLES, ACIDS",
      "helpText": "",
      "label": "DANGEROUS ARTICLES, EXPLOSIVES, CORROSIVES, FLAMMABLES, ACIDS",
      "sequence": 46,
      "value": "DANGEROUS ARTICLES, EXPLOSIVES, CORROSIVES, FLAMMABLES, ACIDS",
      "isEligible": false
    },
    {
      "code": "DEPT. STORE MDSE(MIXED LOADS - E.G. WALMART)",
      "helpText": "",
      "label": "DEPT. STORE MDSE(MIXED LOADS - E.G. WALMART)",
      "sequence": 47,
      "value": "DEPT. STORE MDSE(MIXED LOADS - E.G. WALMART)",
      "isEligible": true
    },
    {
      "code": "DIRT, SAND, GRAVEL AND ROCK",
      "helpText": "",
      "label": "DIRT, SAND, GRAVEL AND ROCK",
      "sequence": 49,
      "value": "DIRT, SAND, GRAVEL AND ROCK",
      "isEligible": true
    },
    {
      "code": "DYES, INK AND PAINTS, NON-HAZARDOUS",
      "helpText": "",
      "label": "DYES, INK AND PAINTS, NON-HAZARDOUS",
      "sequence": 50,
      "value": "DYES, INK AND PAINTS, NON-HAZARDOUS",
      "isEligible": true
    },
    {
      "code": "EGGS",
      "helpText": "",
      "label": "EGGS",
      "sequence": 51,
      "value": "EGGS",
      "isEligible": true
    },
    {
      "code": "ELECTRICAL EQUIPMENT",
      "helpText": "",
      "label": "ELECTRICAL EQUIPMENT",
      "sequence": 52,
      "value": "ELECTRICAL EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "ELECTRICAL SUPPLIES",
      "helpText": "",
      "label": "ELECTRICAL SUPPLIES",
      "sequence": 53,
      "value": "ELECTRICAL SUPPLIES",
      "isEligible": true
    },
    {
      "code": "FEED",
      "helpText": "",
      "label": "FEED",
      "sequence": 54,
      "value": "FEED",
      "isEligible": true
    },
    {
      "code": "FINE ARTS",
      "helpText": "",
      "label": "FINE ARTS",
      "sequence": 56,
      "value": "FINE ARTS",
      "isEligible": false
    },
    {
      "code": "FLOUR",
      "helpText": "",
      "label": "FLOUR",
      "sequence": 57,
      "value": "FLOUR",
      "isEligible": true
    },
    {
      "code": "FLOWERS (CUT)",
      "helpText": "",
      "label": "FLOWERS (CUT)",
      "sequence": 58,
      "value": "FLOWERS (CUT)",
      "isEligible": true
    },
    {
      "code": "FOOD & BEVERAGES NON REFRIGERATED",
      "helpText": "",
      "label": "FOOD & BEVERAGES NON REFRIGERATED",
      "sequence": 59,
      "value": "FOOD & BEVERAGES NON REFRIGERATED",
      "isEligible": true
    },
    {
      "code": "FOOD (FROZEN/NOT SEAFOOD)",
      "helpText": "",
      "label": "FOOD (FROZEN/NOT SEAFOOD)",
      "sequence": 60,
      "value": "FOOD (FROZEN/NOT SEAFOOD)",
      "isEligible": true
    },
    {
      "code": "FURNITURE (NEW)",
      "helpText": "",
      "label": "FURNITURE (NEW)",
      "sequence": 61,
      "value": "FURNITURE (NEW)",
      "isEligible": true
    },
    {
      "code": "GARBAGE",
      "helpText": "",
      "label": "GARBAGE",
      "sequence": 62,
      "value": "GARBAGE",
      "isEligible": false
    },
    {
      "code": "GLASS PRODUCTS",
      "helpText": "",
      "label": "GLASS PRODUCTS",
      "sequence": 63,
      "value": "GLASS PRODUCTS",
      "isEligible": true
    },
    {
      "code": "GRAIN",
      "helpText": "",
      "label": "GRAIN",
      "sequence": 64,
      "value": "GRAIN",
      "isEligible": true
    },
    {
      "code": "HAY",
      "helpText": "",
      "label": "HAY",
      "sequence": 65,
      "value": "HAY",
      "isEligible": true
    },
    {
      "code": "HOUSEHOLD GOODS",
      "helpText": "",
      "label": "HOUSEHOLD GOODS",
      "sequence": 66,
      "value": "HOUSEHOLD GOODS",
      "isEligible": false
    },
    {
      "code": "ICE CREAM",
      "helpText": "",
      "label": "ICE CREAM",
      "sequence": 67,
      "value": "ICE CREAM",
      "isEligible": true
    },
    {
      "code": "IRON (RAW)",
      "helpText": "",
      "label": "IRON (RAW)",
      "sequence": 68,
      "value": "IRON (RAW)",
      "isEligible": true
    },
    {
      "code": "JEWELRY",
      "helpText": "",
      "label": "JEWELRY",
      "sequence": 69,
      "value": "JEWELRY",
      "isEligible": false
    },
    {
      "code": "LEATHER GOODS (OTHER THAN SHOES) HIDE AND SKINS",
      "helpText": "",
      "label": "LEATHER GOODS (OTHER THAN SHOES) HIDE AND SKINS",
      "sequence": 70,
      "value": "LEATHER GOODS (OTHER THAN SHOES) HIDE AND SKINS",
      "isEligible": true
    },
    {
      "code": "LIQUIDS - NON CHEMICAL OR NON PETROLEUM",
      "helpText": "",
      "label": "LIQUIDS - NON CHEMICAL OR NON PETROLEUM",
      "sequence": 71,
      "value": "LIQUIDS - NON CHEMICAL OR NON PETROLEUM",
      "isEligible": true
    },
    {
      "code": "LITHIUM BATTERIES",
      "helpText": "",
      "label": "LITHIUM BATTERIES",
      "sequence": 72,
      "value": "LITHIUM BATTERIES",
      "isEligible": false
    },
    {
      "code": "LOGS",
      "helpText": "",
      "label": "LOGS",
      "sequence": 73,
      "value": "LOGS",
      "isEligible": false
    },
    {
      "code": "LUMBER",
      "helpText": "",
      "label": "LUMBER",
      "sequence": 74,
      "value": "LUMBER",
      "isEligible": true
    },
    {
      "code": "MACHINERY",
      "helpText": "",
      "label": "MACHINERY",
      "sequence": 75,
      "value": "MACHINERY",
      "isEligible": true
    },
    {
      "code": "MARBLE/GRANITE/OTHER STONE SLABS",
      "helpText": "",
      "label": "MARBLE/GRANITE/OTHER STONE SLABS",
      "sequence": 76,
      "value": "MARBLE/GRANITE/OTHER STONE SLABS",
      "isEligible": false
    },
    {
      "code": "MEATS DRESSED POULTRY",
      "helpText": "",
      "label": "MEATS DRESSED POULTRY",
      "sequence": 77,
      "value": "MEATS DRESSED POULTRY",
      "isEligible": true
    },
    {
      "code": "MEDICAL INSTRUMENTS",
      "helpText": "",
      "label": "MEDICAL INSTRUMENTS",
      "sequence": 78,
      "value": "MEDICAL INSTRUMENTS",
      "isEligible": true
    },
    {
      "code": "METAL PRODUCTS",
      "helpText": "",
      "label": "METAL PRODUCTS",
      "sequence": 79,
      "value": "METAL PRODUCTS",
      "isEligible": true
    },
    {
      "code": "MINERALS NON-PRECIOUS",
      "helpText": "",
      "label": "MINERALS NON-PRECIOUS",
      "sequence": 80,
      "value": "MINERALS NON-PRECIOUS",
      "isEligible": true
    },
    {
      "code": "MOBILE / MODULAR HOMES",
      "helpText": "",
      "label": "MOBILE / MODULAR HOMES",
      "sequence": 81,
      "value": "MOBILE / MODULAR HOMES",
      "isEligible": false
    },
    {
      "code": "MULCH/TOP SOIL AND FILL",
      "helpText": "",
      "label": "MULCH/TOP SOIL AND FILL",
      "sequence": 82,
      "value": "MULCH/TOP SOIL AND FILL",
      "isEligible": true
    },
    {
      "code": "MUSICAL INSTRUMENTS",
      "helpText": "",
      "label": "MUSICAL INSTRUMENTS",
      "sequence": 83,
      "value": "MUSICAL INSTRUMENTS",
      "isEligible": true
    },
    {
      "code": "NARCOTICS",
      "helpText": "",
      "label": "NARCOTICS",
      "sequence": 84,
      "value": "NARCOTICS",
      "isEligible": false
    },
    {
      "code": "OFFICE EQUIPMENT",
      "helpText": "",
      "label": "OFFICE EQUIPMENT",
      "sequence": 85,
      "value": "OFFICE EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "OILFIELD EQUIPMENT",
      "helpText": "",
      "label": "OILFIELD EQUIPMENT",
      "sequence": 86,
      "value": "OILFIELD EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "OILS (EDIBLE)",
      "helpText": "",
      "label": "OILS (EDIBLE)",
      "sequence": 87,
      "value": "OILS (EDIBLE)",
      "isEligible": true
    },
    {
      "code": "ORE",
      "helpText": "",
      "label": "ORE",
      "sequence": 88,
      "value": "ORE",
      "isEligible": true
    },
    {
      "code": "OTHER AUTOS AIRCRAFT",
      "helpText": "",
      "label": "OTHER AUTOS AIRCRAFT",
      "sequence": 89,
      "value": "OTHER AUTOS AIRCRAFT",
      "isEligible": true
    },
    {
      "code": "OTHER BUILDING SUPPLIES",
      "helpText": "",
      "label": "OTHER BUILDING SUPPLIES",
      "sequence": 90,
      "value": "OTHER BUILDING SUPPLIES",
      "isEligible": true
    },
    {
      "code": "OTHER CONSTRUCTION MATERIALS(RAW)",
      "helpText": "",
      "label": "OTHER CONSTRUCTION MATERIALS(RAW)",
      "sequence": 91,
      "value": "OTHER CONSTRUCTION MATERIALS(RAW)",
      "isEligible": true
    },
    {
      "code": "OTHER CONSUMER GOODS",
      "helpText": "",
      "label": "OTHER CONSUMER GOODS",
      "sequence": 92,
      "value": "OTHER CONSUMER GOODS",
      "isEligible": true
    },
    {
      "code": "OTHER FARMING / AGRICULTURE, INCLUDING AG EQUIP",
      "helpText": "",
      "label": "OTHER FARMING / AGRICULTURE, INCLUDING AG EQUIP",
      "sequence": 93,
      "value": "OTHER FARMING / AGRICULTURE, INCLUDING AG EQUIP",
      "isEligible": true
    },
    {
      "code": "OTHER LIVESTOCK",
      "helpText": "",
      "label": "OTHER LIVESTOCK",
      "sequence": 94,
      "value": "OTHER LIVESTOCK",
      "isEligible": false
    },
    {
      "code": "OTHER MACHINERY AND EQUIPMENT",
      "helpText": "",
      "label": "OTHER MACHINERY AND EQUIPMENT",
      "sequence": 95,
      "value": "OTHER MACHINERY AND EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "OTHER METALS",
      "helpText": "",
      "label": "OTHER METALS",
      "sequence": 96,
      "value": "OTHER METALS",
      "isEligible": true
    },
    {
      "code": "OTHER PAPER/PLASTIC/GLASS",
      "helpText": "",
      "label": "OTHER PAPER/PLASTIC/GLASS",
      "sequence": 97,
      "value": "OTHER PAPER/PLASTIC/GLASS",
      "isEligible": true
    },
    {
      "code": "OTHER TEXTILES / SKINS/FURS",
      "helpText": "",
      "label": "OTHER TEXTILES / SKINS/FURS",
      "sequence": 98,
      "value": "OTHER TEXTILES / SKINS/FURS",
      "isEligible": true
    },
    {
      "code": "PACKING MATERIAL AND SUPPLIES",
      "helpText": "",
      "label": "PACKING MATERIAL AND SUPPLIES",
      "sequence": 99,
      "value": "PACKING MATERIAL AND SUPPLIES",
      "isEligible": true
    },
    {
      "code": "PAPER AND PAPER PRODUCTS",
      "helpText": "",
      "label": "PAPER AND PAPER PRODUCTS",
      "sequence": 100,
      "value": "PAPER AND PAPER PRODUCTS",
      "isEligible": true
    },
    {
      "code": "PETROLEUM PRODUCTS 140 - 200 DEGREES FLASHPOINT",
      "helpText": "",
      "label": "PETROLEUM PRODUCTS 140 - 200 DEGREES FLASHPOINT",
      "sequence": 101,
      "value": "PETROLEUM PRODUCTS 140 - 200 DEGREES FLASHPOINT",
      "isEligible": false
    },
    {
      "code": "PETROLEUM PRODUCTS OVER 200 DEGREES FLASHPOINT",
      "helpText": "",
      "label": "PETROLEUM PRODUCTS OVER 200 DEGREES FLASHPOINT",
      "sequence": 102,
      "value": "PETROLEUM PRODUCTS OVER 200 DEGREES FLASHPOINT",
      "isEligible": false
    },
    {
      "code": "PETROLEUM PRODUCTS UNDER 140 DEGREES FLASHPOINT",
      "helpText": "",
      "label": "PETROLEUM PRODUCTS UNDER 140 DEGREES FLASHPOINT",
      "sequence": 103,
      "value": "PETROLEUM PRODUCTS UNDER 140 DEGREES FLASHPOINT",
      "isEligible": false
    },
    {
      "code": "PHARMACEUTICALS OTHER THAN NARCOTICS",
      "helpText": "",
      "label": "PHARMACEUTICALS OTHER THAN NARCOTICS",
      "sequence": 104,
      "value": "PHARMACEUTICALS OTHER THAN NARCOTICS",
      "isEligible": false
    },
    {
      "code": "PHARMACEUTICALS OVER THE COUNTER",
      "helpText": "",
      "label": "PHARMACEUTICALS OVER THE COUNTER",
      "sequence": 105,
      "value": "PHARMACEUTICALS OVER THE COUNTER",
      "isEligible": true
    },
    {
      "code": "PIPE",
      "helpText": "",
      "label": "PIPE",
      "sequence": 106,
      "value": "PIPE",
      "isEligible": true
    },
    {
      "code": "PLANTS/SHRUBS/TREES (NOT TEMP CONTROLLED)",
      "helpText": "",
      "label": "PLANTS/SHRUBS/TREES (NOT TEMP CONTROLLED)",
      "sequence": 107,
      "value": "PLANTS/SHRUBS/TREES (NOT TEMP CONTROLLED)",
      "isEligible": true
    },
    {
      "code": "PLANTS/SHRUBS/TREES(TEMP CONTROLLED)",
      "helpText": "",
      "label": "PLANTS/SHRUBS/TREES(TEMP CONTROLLED)",
      "sequence": 108,
      "value": "PLANTS/SHRUBS/TREES(TEMP CONTROLLED)",
      "isEligible": true
    },
    {
      "code": "PLASTIC PRODUCTS",
      "helpText": "",
      "label": "PLASTIC PRODUCTS",
      "sequence": 109,
      "value": "PLASTIC PRODUCTS",
      "isEligible": true
    },
    {
      "code": "PLUMBING SUPPLIES",
      "helpText": "",
      "label": "PLUMBING SUPPLIES",
      "sequence": 110,
      "value": "PLUMBING SUPPLIES",
      "isEligible": true
    },
    {
      "code": "POULTRY (LIVE)",
      "helpText": "",
      "label": "POULTRY (LIVE)",
      "sequence": 111,
      "value": "POULTRY (LIVE)",
      "isEligible": false
    },
    {
      "code": "PRECIOUS METALS",
      "helpText": "",
      "label": "PRECIOUS METALS",
      "sequence": 112,
      "value": "PRECIOUS METALS",
      "isEligible": false
    },
    {
      "code": "PRINTED MATERIAL",
      "helpText": "",
      "label": "PRINTED MATERIAL",
      "sequence": 113,
      "value": "PRINTED MATERIAL",
      "isEligible": true
    },
    {
      "code": "PRODUCE",
      "helpText": "",
      "label": "PRODUCE",
      "sequence": 114,
      "value": "PRODUCE",
      "isEligible": true
    },
    {
      "code": "RAW TOBACCO LEAF (BULK)",
      "helpText": "",
      "label": "RAW TOBACCO LEAF (BULK)",
      "sequence": 115,
      "value": "RAW TOBACCO LEAF (BULK)",
      "isEligible": true
    },
    {
      "code": "RECYCLING MATERIALS",
      "helpText": "",
      "label": "RECYCLING MATERIALS",
      "sequence": 116,
      "value": "RECYCLING MATERIALS",
      "isEligible": true
    },
    {
      "code": "RESINS",
      "helpText": "",
      "label": "RESINS",
      "sequence": 117,
      "value": "RESINS",
      "isEligible": true
    },
    {
      "code": "RUBBER PRODUCT NOT TIRES",
      "helpText": "",
      "label": "RUBBER PRODUCT NOT TIRES",
      "sequence": 118,
      "value": "RUBBER PRODUCT NOT TIRES",
      "isEligible": true
    },
    {
      "code": "RV’S",
      "helpText": "",
      "label": "RV’S",
      "sequence": 119,
      "value": "RV’S",
      "isEligible": false
    },
    {
      "code": "SALT",
      "helpText": "",
      "label": "SALT",
      "sequence": 120,
      "value": "SALT",
      "isEligible": true
    },
    {
      "code": "SCIENTIFIC INSTRUMENTS AND EQUIPMENT",
      "helpText": "",
      "label": "SCIENTIFIC INSTRUMENTS AND EQUIPMENT",
      "sequence": 121,
      "value": "SCIENTIFIC INSTRUMENTS AND EQUIPMENT",
      "isEligible": true
    },
    {
      "code": "SCRAP METAL",
      "helpText": "",
      "label": "SCRAP METAL",
      "sequence": 122,
      "value": "SCRAP METAL",
      "isEligible": true
    },
    {
      "code": "SEAFOOD (FRESH)",
      "helpText": "",
      "label": "SEAFOOD (FRESH)",
      "sequence": 123,
      "value": "SEAFOOD (FRESH)",
      "isEligible": false
    },
    {
      "code": "SEAFOOD (FROZEN)",
      "helpText": "",
      "label": "SEAFOOD (FROZEN)",
      "sequence": 124,
      "value": "SEAFOOD (FROZEN)",
      "isEligible": true
    },
    {
      "code": "SEEDS",
      "helpText": "",
      "label": "SEEDS",
      "sequence": 125,
      "value": "SEEDS",
      "isEligible": true
    },
    {
      "code": "SPAS HOT TUBS",
      "helpText": "",
      "label": "SPAS HOT TUBS",
      "sequence": 126,
      "value": "SPAS HOT TUBS",
      "isEligible": true
    },
    {
      "code": "SPICES",
      "helpText": "",
      "label": "SPICES",
      "sequence": 127,
      "value": "SPICES",
      "isEligible": true
    },
    {
      "code": "SPORTING GOODS",
      "helpText": "",
      "label": "SPORTING GOODS",
      "sequence": 128,
      "value": "SPORTING GOODS",
      "isEligible": true
    },
    {
      "code": "STEEL",
      "helpText": "",
      "label": "STEEL",
      "sequence": 129,
      "value": "STEEL",
      "isEligible": true
    },
    {
      "code": "STONE",
      "helpText": "",
      "label": "STONE",
      "sequence": 130,
      "value": "STONE",
      "isEligible": true
    },
    {
      "code": "SWINE",
      "helpText": "",
      "label": "SWINE",
      "sequence": 131,
      "value": "SWINE",
      "isEligible": false
    },
    {
      "code": "TEA/COFFEE",
      "helpText": "",
      "label": "TEA/COFFEE",
      "sequence": 132,
      "value": "TEA/COFFEE",
      "isEligible": true
    },
    {
      "code": "TEXTILES",
      "helpText": "",
      "label": "TEXTILES",
      "sequence": 133,
      "value": "TEXTILES",
      "isEligible": true
    },
    {
      "code": "TIRES",
      "helpText": "",
      "label": "TIRES",
      "sequence": 134,
      "value": "TIRES",
      "isEligible": false
    },
    {
      "code": "TOILET AND SOAP PRODUCTS",
      "helpText": "",
      "label": "TOILET AND SOAP PRODUCTS",
      "sequence": 135,
      "value": "TOILET AND SOAP PRODUCTS",
      "isEligible": true
    },
    {
      "code": "TOOLS",
      "helpText": "",
      "label": "TOOLS",
      "sequence": 136,
      "value": "TOOLS",
      "isEligible": true
    },
    {
      "code": "TOYS",
      "helpText": "",
      "label": "TOYS",
      "sequence": 137,
      "value": "TOYS",
      "isEligible": true
    },
    {
      "code": "TRAVEL TRAILERS",
      "helpText": "",
      "label": "TRAVEL TRAILERS",
      "sequence": 138,
      "value": "TRAVEL TRAILERS",
      "isEligible": false
    },
    {
      "code": "TV RADIO STEREO CELL PHONE OTHER PERSONAL ELECTRONIC EQUIPMENT",
      "helpText": "",
      "label": "TV RADIO STEREO CELL PHONE OTHER PERSONAL ELECTRONIC EQUIPMENT",
      "sequence": 139,
      "value": "TV RADIO STEREO CELL PHONE OTHER PERSONAL ELECTRONIC EQUIPMENT",
      "isEligible": false
    },
    {
      "code": "WIRE NOT FIBER OPTIC",
      "helpText": "",
      "label": "WIRE NOT FIBER OPTIC",
      "sequence": 140,
      "value": "WIRE NOT FIBER OPTIC",
      "isEligible": true
    },
    {
      "code": "WOOD PRODUCTS NOT FURNITURE AND CASKETS",
      "helpText": "",
      "label": "WOOD PRODUCTS NOT FURNITURE AND CASKETS",
      "sequence": 141,
      "value": "WOOD PRODUCTS NOT FURNITURE AND CASKETS",
      "isEligible": true
    },
    {
      "code": "ZINC",
      "helpText": "",
      "label": "ZINC",
      "sequence": 142,
      "value": "ZINC",
      "isEligible": true
    }
  ]

  public static InvalidCommoditiesForMTC: Array<string> = [
    "CATTLE",
    "OTHER LIVESTOCK",
    "POULTRY (LIVE)",
    "SCRAP METAL",
    "SEAFOOD (FRESH)",
    "SWINE"
  ];
}